import { resolveTerminology } from '@cogo/validator/terminology'

export interface StudioTargetResolution {
  rawTerm: string
  elementType: string | null
  status: 'resolved' | 'ambiguous' | 'undefined'
}

export function resolveStudioTargetTerm(
  rawTerm: string,
  applicationScope?: string,
): StudioTargetResolution {
  const result = resolveTerminology(rawTerm, {
    kinds: ['element-type'],
    applicationScope,
    minScore: 0.8,
  })

  if (result.exact) {
    return {
      rawTerm,
      elementType: result.exact.id,
      status: 'resolved',
    }
  }

  if (result.undefinedTerm) {
    return {
      rawTerm,
      elementType: null,
      status: 'undefined',
    }
  }

  const topScore = result.candidates[0]?.score
  const equallyRanked = result.candidates.filter(
    (candidate) => candidate.score === topScore,
  )
  if (topScore === 1 && equallyRanked.length === 1) {
    return {
      rawTerm,
      elementType: equallyRanked[0].entry.id,
      status: 'resolved',
    }
  }

  return {
    rawTerm,
    elementType: null,
    status: 'ambiguous',
  }
}
